import * as React from 'react';
import { cx, toneClass, type MotionTone } from '../tone';

export interface GpsPulseProps {
  /** Diameter of the centre-dot zone in px. @default 18 */
  size?: number;
  /** Accent tone. @default 'teal' */
  tone?: MotionTone;
  /** Accessible status label. @default 'Locating' */
  label?: string;
  /** Extra classes on the root. */
  className?: string;
  /** Inline style on the root. */
  style?: React.CSSProperties;
}

/**
 * `GpsPulse` — "locating you": concentric Skyline rings expanding from a
 * glowing dot. Use on the map surface while geolocation resolves. Rings
 * collapse to the resting dot under `prefers-reduced-motion`.
 */
export function GpsPulse({
  size = 18,
  tone = 'teal',
  label = 'Locating',
  className,
  style,
}: GpsPulseProps): React.ReactElement {
  return (
    <span
      role="status"
      aria-label={label}
      className={cx('lm-gps', toneClass(tone), className)}
      style={{ width: size, height: size, ...style }}
    >
      <span className="lm-gps__dot" />
      <span className="lm-gps__ring" />
      <span className="lm-gps__ring" />
      <span className="lm-gps__ring" />
    </span>
  );
}
